import script from "./FormTextEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./FormTextEditor.vue?vue&type=script&setup=true&lang=js"

import "./FormTextEditor.vue?vue&type=style&index=0&id=1eb1174f&lang=scss"

export default script